import React from 'react';
import PropTypes from 'prop-types';

class PanaromaBackground extends React.Component
{
    render()
    {
        return (<img
            src={this.props.backgroundImage}
            className="fadejs"
            alt="Panaroma Background"
            style={{
            display: "block",
            objectFit: "cover",
            maxHeight: "100vh",
            transform: `translate(${((this.props.runDistance - this.props.offset) * this.props.speed)}%, 0px)`,
            width: "auto",
            height: "100vh",
        }}/>);
    }
}

PanaromaBackground.propTypes = {
    backgroundImage: PropTypes.string,
    blur: PropTypes.number,
    scale: PropTypes.number,
    speed: PropTypes.number,
    offset: PropTypes.number,
    runDistance: PropTypes.number,
    onImageLoaded: PropTypes.func
};

PanaromaBackground.defaultProps = {
    backgroundImage: 'GenericButton',
    blur: 0,
    scale: 1,
    speed: 1,
    offset: 0,
    runDistance: 0,
    onImageLoaded: function () {
        console.log("On PanaromaBackground loaded");
    }
};

export default PanaromaBackground;
